/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCircularProgress4 = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2c5.523 0 10 4.477 10 10 0 5.43-4.326 9.848-9.72 9.996L12 22v-2a8 8 0 0 0 8-8 8 8 0 0 0-7.75-7.996L12 4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCircularProgress4 as CircularProgress4 };
